import i18next from 'i18next'

i18next.addResources('es', 'floatingButton', {
  whatsAppTitle: 'WhatsApp',
  helpUsToImproveTitle: 'Ayúdanos a mejorar'
})
